module.exports = __webpack_public_path__ + "static/media/meh-regular-active.edcc0217.svg";